import Card from "components/card";
import React, {useMemo, useState} from "react";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import useAsyncEffect from "use-async-effect";
import DataPointsTable from "./DataPointsTable";
import Alerts from "../../../error";
import {columnsDataAclOverview} from "../../../users/variables/columnsDataAclOverview";
import {columnsDataDpOverview} from "../../variables/columnsDataDpOverview";
import FirmwareUploadStatsTable from "./FirmwareUploadStatsTable";
import {columnsDataFirmwareHistoryOverview} from "../../variables/columnsDataFirmwareHistoryOverview";

const FirmwareUploadHistory = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

        //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
        //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
        const secretKey = "cromptonssecretkey";

        let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
        const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
        const navigate = useNavigate();
        const [loading, setLoading] = useState(true);
        let [data, setData] = useState([])
        const params = useParams();

        const handleLogOut = async () => {
            try {
                await logOut();
                navigate("/");
            } catch (error) {
                ////console.log(error.message);
            }
        }

        useAsyncEffect(async () => {
                //console.log(accesscontrollevel)
                if (accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5"))  {
                    var url = CROMPTON_ANALYTICS_URL + "v1/device/firmware/all/" + params.id

                    await axios({
                        method: "GET", url: url, headers: {
                            Authorization: decryptedValue,
                        }

                    }).then((res) => {
                        console.log(res.data)
                        setData(res.data)

                    }).catch((error) => {
                        //console.log(error)
                        if (error.response.data.status === "401" || error.response.data.status === "403") {
                            handleLogOut();
                        }
                    })
                }
                setLoading(false)

            }, []
        );

        return (

            !loading &&
            <Card extra={'w-full h-full mt-3 p-4'}>
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "2" ?
                    <FirmwareUploadStatsTable
                        tableData={data}
                        columnsData={columnsDataFirmwareHistoryOverview}
                    /> : <Alerts/>}
            </Card>
        )
            ;
    }
;

export default FirmwareUploadHistory;
